<template slot-scope="scope">
  <div class="page bg-fff">
    <appStatus :statusHeight="statusHeight"></appStatus>
    <div class="page-title" :style="{ top: statusHeight + 'rem' }">
      <div class="color-333 fs-36">{{ countEntity.shopName || userName }}</div>
      <div class="flex-center">
        <div
                class="right-icon alifont icon-refresh click mr-20"
                v-if="!isQuarterManageRole && !isMaintenanceRole"
                @click="refreshOrderCount"
        ></div>
        <div

                class="right-icon alifont icon-xiaoxi click"
                v-if="!isQuarterManageRole && !isMaintenanceRole"
                @click="$router.push({ name: 'messageList' })"
        ></div>
      </div>
    </div>
    <div class="pd-025">
      <div
              class="sys-tip click"
              v-if="curNotice"
              @click="$router.push({ name: 'noticeList' })"
      >
        <div class="alifont icon-tongzhi left"></div>
        <div class="text fs-28 text-el">{{ curNotice.title }}</div>
        <div class="alifont icon-fanhui1 right"></div>
      </div>
      <div class="main-content" v-if="isQuarterManageRole || isAdministorRole">
        <div class="opc"></div>
        <div style="position: relative; z-index: 10" v-if="!isEquipmentApp">
          <div class="fs-28 color-fff">今日销售金额(元)</div>
          <div
                  class="sale-money number_font click"
                  @click="$router.push({ name: 'incomeDetail' })"
          >
            {{ formatNumber(countEntity.salesCount || 0) }}
          </div>
          <div class="yesterday">
            昨日金额
            <span class="number_font">{{
              formatNumber(countEntity.yesterdaySalesCount || 0)
            }}</span>
          </div>
          <div class="flex mt-20">
            <div class="flex1">
              <div class="fs-26 color-fff opc-08">今日客单价(元)</div>
              <div class="fs-36 color-fff number_font">
                {{ formatNumber(countEntity.atv || 0) }}
              </div>
            </div>
            <div
                    class="flex1 click"
                    @click="$router.push({ name: 'orderList' })"
            >
              <div class="fs-26 color-fff opc-08">今日订单数</div>
              <div class="fs-36 color-fff number_font">
                {{ formatNumber(countEntity.orderCount || 0) }}
              </div>
            </div>
            <div class="flex1">
              <div class="fs-26 color-fff opc-08">今日售后数</div>
              <div class="fs-36 color-fff number_font">
                {{ formatNumber(countEntity.orderServiceCount || 0) }}
              </div>
            </div>
          </div>
        </div>

        <div style="position: relative; z-index: 10" v-if="isEquipmentApp">
          <div class="fs-28 color-fff">今日销售金额(元)</div>
          <div class="sale-money number_font click">
            {{ formatNumber(countEntity.totalAmountCount || 0) }}
          </div>
          <!--                    <div class="yesterday" v-if="!isEquipmentApp">昨日金额  <span class="number_font">{{formatNumber(countEntity.yesterdaySalesCount || 0)}}</span></div>-->
          <div class="flex mt-20">
            <div class="flex1" v-if="false">
              <div class="fs-26 color-fff opc-08">今日客单价(元)</div>
              <div class="fs-36 color-fff number_font">
                {{ formatNumber(countEntity.atv || 0) }}
              </div>
            </div>
            <div class="flex1 click">
              <div class="fs-26 color-fff opc-08">今日订单数</div>
              <div class="fs-36 color-fff number_font">
                {{ formatNumber(countEntity.totalOrderCount || 0) }}
              </div>
            </div>
            <div class="flex1" v-if="false">
              <div class="fs-26 color-fff opc-08">今日售后数</div>
              <div class="fs-36 color-fff number_font">
                {{ formatNumber(countEntity.orderServiceCount || 0) }}
              </div>
            </div>
            <div class="flex1" v-if="false">
              <div class="fs-26 color-fff opc-08">今日异常</div>
              <div class="fs-36 color-fff number_font">
                {{ formatNumber(countEntity.orderServiceCount || 0) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
              class="flex order-tip fs-32 color-333" v-if="isAdministorRole || isStockManagerRole" >
        <div
                class="flex1 text-center click left"
                @click="$router.push({ name: 'waitSendOrderList' })"
        >
          待打印
          <span class="color-red ml-20 number_font">{{
            formatNumber(orderCountEntity.waitPrintNum || 0)
          }}</span>
        </div>
        <div
                class="flex1 text-center click left"
                @click="$router.push({ name: 'waitSendOrderList' })"
        >
          待发货
          <span class="color-main ml-20 number_font">{{
            formatNumber(orderCountEntity.waitShipNum || 0)
          }}</span>
        </div>
        <div
                class="flex1 text-center click"
                @click="$router.push({ name: 'waitFinishOrderList' })"
        >
          待完成
          <span class="color-org ml-20 number_font">{{
            formatNumber(orderCountEntity.waitReceiveNum || 0)
          }}</span>
        </div>
      </div>
      <div class="com-content" v-if="isEquipmentApp || isQuarterManageRole || isAdministorRole">
        <div class="fs-36 color-333 font-bold">预警</div>
        <div class="content-list">
          <div
                  class="content-item click"
                  v-for="(item, $index) in warningList"
                  :key="$index"
                  @click="goUrl(item)"
          >
            <img :src="item.img" alt="" />
            <div class="fs-28 color-333 mt-10">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="com-content" v-if="isQuarterManageRole || isMaintenanceRole ||isAdministorRole">
        <div class="fs-36 color-333 font-bold">数据管理</div>
        <div class="content-list">
          <div
                  class="content-item click"
                  v-for="(item, $index) in saleDataList"
                  :key="$index"
                  @click="goUrl(item)"
          >
            <img :src="item.img" alt="" />
            <div class="fs-28 color-333 mt-10">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="com-content" v-if="isQuarterManageRole || isMaintenanceRole   ||isAdministorRole">
        <div class="fs-36 color-333 font-bold">小区管理</div>
        <div class="content-list">
          <div
                  class="content-item click"
                  v-for="(item, $index) in manageList"
                  :key="$index"
                  @click="goUrl(item)"
          >
            <img :src="item.img" alt="" />
            <div class="fs-28 color-333 mt-10">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="com-content" v-if="isStockManagerRole||isAdministorRole">
        <div class="fs-36 color-333 font-bold">仓库管理</div>
        <div class="content-list">
          <div
                  class="content-item click"
                  v-for="(item, $index) in stockList"
                  :key="$index"
                  @click="goUrl(item)"
          >
            <img :src="item.img" alt="" />
            <div class="fs-28 color-333 mt-10">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="com-content" v-if="isDriverRole||isSupplierRole||isAdministorRole">
        <div class="fs-36 color-333 font-bold">司机接货</div>
        <div class="content-list">
          <div
                  class="content-item click"
                  v-for="(item, $index) in driverList"
                  :key="$index"
                  @click="goUrl(item)"
          >
            <img :src="item.img" alt="" />
            <div class="fs-28 color-333 mt-10">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="com-content" v-if="isQuarterManageRole || isAdministorRole || isMaintenanceRole">
        <div class="fs-36 color-333 font-bold">明细分析</div>
        <div class="content-list">
          <div
                  class="content-item click"
                  v-for="(item, $index) in analysisList"
                  :key="$index"
                  @click="goUrl(item)"
          >
            <img :src="item.img" alt="" />
            <div class="fs-28 color-333 mt-10">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="com-content">
        <div class="fs-36 color-333 font-bold">设置</div>
        <div class="content-list">
          <div
                  class="content-item click"
                  v-for="(item, $index) in settingList"
                  :key="$index"
                  @click="goUrl(item)"
          >
            <img :src="item.img" alt="" />
            <div class="fs-28 color-333 mt-10">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <img
            :src="scanImg"
            alt=""
            class="scan-img click"
            @click="scan"
    />
  </div>
</template>
<script>
  import {
    qryShopDetail,
    qryShopInfoCount,
    checkOrder,
    openDoorForAdmin,
  } from "@/api/shop";
  import { getOrderCountNum } from "@/api/order";
  import { getAccountCount, getWXconfigParams } from "@/api/user";
  import { myMsgNoticeList } from "@/api/msg";
  import { isURL, parseUrl, getToken, readUserAgent } from "@/utils/util";
  import util from "@/utils/index";
  import getAppParams from "@/mixins/getAppParams";
  import appStatus from "@/components/appStatus/index";
  import getAppStatusHeight from "@/mixins/getAppStatusHeight";
  import config from "@/config";
  import { mapActions } from "vuex";
  import wx from "weixin-js-sdk";
  export default {
    name: "Home",
    mixins: [getAppParams, getAppStatusHeight],
    components: { appStatus },
    computed: {
      manageList: function () {
        if (this.isEquipmentApp) {
          return this.manageList2;
        } else {
          return this.manageList1;
        }
      },
      settingList: function () {
        if (this.isEquipmentApp) {
          if (
                  this.$store.state.user &&
                  this.$store.state.user.userRoleList.length > 1
          ) {
            return [
              {
                name: "个人中心",
                img: require("../assets/images/shopHome/tag9.png"),
                url: "userCenter",
                isToApp: true,
                appMethod: "toMine",
              },
              {
                name: "联系客服",
                img: require("../assets/images/shopHome/tag10.png"),
                url: "contact",
              },
              {
                name: "切换角色",
                img: require("../assets/images/shopHome/tag21.png"),
                url: "roleList",
              },
              {
                name: "释放容器码",
                img: require("../assets/images/shopHome/tag100.png"),
                url: "WareVolCodeFree",
              },
            ];
          } else {
            return [
              {
                name: "个人中心",
                img: require("../assets/images/shopHome/tag9.png"),
                url: "userCenter",
                isToApp: true,
                appMethod: "toMine",
              },
              {
                name: "联系客服",
                img: require("../assets/images/shopHome/tag10.png"),
                url: "contact",
              },
            ];
          }
        } else {
          if (
                  this.$store.state.user &&
                  this.$store.state.user.userRoleList.length > 1
          ) {
            return [
              {
                name: "店铺设置",
                img: require("../assets/images/shopHome/tag8.png"),
                url: "settingMain",
              },
              {
                name: "个人中心",
                img: require("../assets/images/shopHome/tag9.png"),
                url: "userCenter",
                isToApp: true,
                appMethod: "toMine",
              },
              {
                name: "联系客服",
                img: require("../assets/images/shopHome/tag10.png"),
                url: "contact",
              },
              {
                name: "切换角色",
                img: require("../assets/images/shopHome/tag21.png"),
                url: "roleList",
              },
            ];
          } else {
            return this.orginSettingList;
          }
        }
      },
    },
    data() {
      return {
        //商家端app管理菜单
        manageList1: [
          {
            name: "发布商品",
            img: require("../assets/images/shopHome/tag1.png"),
            url: "saveProduct",
          },
          {
            name: "商品列表",
            img: require("../assets/images/shopHome/tag2.png"),
            url: "productList",
          },
          // {
          //   name: "活动申请",
          //   img: require("../assets/images/shopHome/tag4.png"),
          //   url: "planShopApplyList",
          // },
          // {
          //   name: "销售数据",
          //   img: require("../assets/images/shopHome/tag4.png"),
          //   url: "shopSaleDataAdd",
          // },
          // {
          //   name: "补货确认",
          //   img: require("../assets/images/shopHome/tag6.png"),
          //   url: "orgReplenishList",
          // },
          // {name:'核销',img:require("../assets/images/shopHome/tag20.png"),url:'verification'},
          // {name:'促销管理',img:require("../assets/images/shopHome/tag3.png"),url:'overDateList'},
          // {name:'活动报名',img:require("../assets/images/shopHome/tag4.png"),url:'supplyRecordList'},
        ],
        //设备 补货端app管理菜单
        manageList2: [

          // {
          //   name: "销售数据",
          //   img: require("../assets/images/shopHome/tag4.png"),
          //   url: "shopSaleDataAdd",
          // },
          // {
          //   name: "补货确认",
          //   img: require("../assets/images/shopHome/tag6.png"),
          //   url: "orgReplenishList",
          // },
          {
            name: "收银",
            img: require("../assets/images/shopHome/tag88.png"),
            url: "localPos",
          },
          {
            name: "柜子补货",
            img: require("../assets/images/shopHome/tag15.png"),
            url: "supplyRecordList",
          },
          {
            name: "柜子盘点",
            img: require("../assets/images/shopHome/tag60.png"),
            url: "equStocktaking",
          },
          {
            name: "活动店铺盘点",
            img: require("../assets/images/shopHome/tag26.png"),
            url: "shopStocktaking",
          },
          {
            name: "店铺列表",
            img: require("../assets/images/shopHome/tag16.png"),
            url: "equipmentList",
          },
          {
            name: "寄存柜管理",
            img: require("../assets/images/shopHome/tag17.png"),
            url: "lockerHouseList",
          },
          {
            name: "补货申请",
            img: require("../assets/images/shopHome/tag22.png"),
            url: "planShopApplyList",
          },

          {
            name: "退回申请",
            img: require("../assets/images/shopHome/tag25.png"),
            url: "wareStoreReturnApply",
          },
          {
            name: "调拨申请",
            img: require("../assets/images/shopHome/tag31.png"),
            url: "WareProdTransfer",
          },
          {
            name: "到货签收",
            img: require("../assets/images/shopHome/tab29.png"),
            url: "WareDeliverSortingListForROrg",
          },
          {
            name: "收银订单",
            img: require("../assets/images/shopHome/tag50.png"),
            url: "posOrderList",
          },

          {
            name: "NFC",
            img: require("../assets/images/shopHome/tag19.png"),
            isToApp: true,
            appMethod: "nfc",
          },
        ],
        driverList:[
          {
            name: "司机配送",
            img: require("../assets/images/shopHome/tag30.png"),
            url: "WareDeliverSortingListForD",
          },
          {
            name: "一键接货",
            img: require("../assets/images/shopHome/tag23.png"),
            url: "WareProdSortingOneClickTake",
          }
        ],
        stockList:[
          {
            name: "库存管理",
            img: require("../assets/images/shopHome/tag27.png"),
            url: "stockInfo",
          },
          {
            name: "收货管理",
            img: require("../assets/images/shopHome/tag28.png"),
            url: "WareReceiptCheck",
          },
          {
            name: "拣货管理",
            img: require("../assets/images/shopHome/tag23.png"),
            url: "WareProdSorting",
          },
          {
            name: "配送分拣",
            img: require("../assets/images/shopHome/tag24.png"),
            url: "WareDeliverSorting",
          },
          {
            name: "库存生产",
            img: require("../assets/images/shopHome/tag35.png"),
            url: "stockProduce",
          },
          {
            name: "库存盘点",
            img: require("../assets/images/shopHome/tag26.png"),
            url: "WareStocktaking",
          },
          {
            name: "到货签收",
            img: require("../assets/images/shopHome/tab29.png"),
            url: "WareDeliverSortingListForR",
          },
          // {
          //   name: "司机配送",
          //   img: require("../assets/images/shopHome/tag30.png"),
          //   url: "WareDeliverSortingListForD",
          // },
        ],
        analysisList: [
          // {name:'数据分析',img:require("../assets/images/shopHome/tag5.png"),url:'shopRegisterShopType'},
          {
            name: "订单明细",
            img: require("../assets/images/shopHome/tag6.png"),
            url: "orderList",
          },
          {
            name: "收入明细",
            img: require("../assets/images/shopHome/tag7.png"),
            url: "incomeDetail",
          },
        ],
        orginSettingList: [
          {
            name: "店铺设置",
            img: require("../assets/images/shopHome/tag8.png"),
            url: "settingMain",
          },
          {
            name: "个人中心",
            img: require("../assets/images/shopHome/tag9.png"),
            url: "userCenter",
            isToApp: true,
            appMethod: "toMine",
          },
          {
            name: "联系客服",
            img: require("../assets/images/shopHome/tag10.png"),
            url: "contact",
          },
        ],
        warningList: [
          {
            name: "过期预警",
            img: require("../assets/images/shopHome/tag18.png"),
            url: "overDateWarning",
          },
          {
            name: "已过期",
            img: require("../assets/images/shopHome/tag11.png"),
            url: "overDateList",
          },
          {
            name: "异常预警",
            img: require("../assets/images/shopHome/tag12.png"),
            url: "errorWarning",
          },
          {
            name: "缺货柜子",
            img: require("../assets/images/shopHome/tag13.png"),
            url: "disStockCabinet",
          },
        ],
        saleDataList: [
          {
            name: "商城销售数据",
            img: require("../assets/images/shopHome/tag14.png"),
            url: "marketingDaily",
          },
          {
            name: "设备销售数据",
            img: require("../assets/images/shopHome/tag14.png"),
            url: "marketingDaily2",
          },
        ],
        scanImg: require("../assets/images/shopHome/scan_" + config.projectName + ".png"),
        dateValue: util.formatDate(new Date(), "yyyy-MM-dd"),
        countEntity: {
          shopName:'',
          totalAmountCount:0
        },
        curNotice: "",
        isEquipmentApp: false,
        shopId: this.$store.state.user.shopId,
        userName: this.$store.state.user.userName,
        timer: null,
        time: 5,
        otype: "",
        eqType: "",
        eqShopId: "",
        orderCountEntity: {},
        isMaintenanceRole:this.$store.state.user.isMaintenanceRole || false,
        isStockManagerRole:this.$store.state.user.isStockManagerRole || false,
        isQuarterManageRole: this.$store.state.user.isQuarterManageRole || false,
        isSupplierRole: this.$store.state.user.isSupplierRole || false,
        isDriverRole: this.$store.state.user.isDriverRole || false,
        isAdministorRole:this.$store.state.user.isAdministorRole || false,
        isOutSupplierRole:this.$store.state.user.isOutSupplierRole || false,
        aliasName: this.$store.state.aliasName || config.projectName,
      }
    },
    created() {
      console.info("--------home created-------")
      this.countEntity = {};
      this.orderCountEntity = {};
      console.log(this.$store.state.user);
      if ((!this.$route.query.shopId && !this.$store.state.user.shopId) ||( this.$store.state.user.shopId == '0')) {
        this.isEquipmentApp = true;
      } else {
        this.isEquipmentApp = false;
      }
      if (readUserAgent().terminalType.weixin) {
        this.getWXConfig();
      }
      // this.getWXConfig();
      if (this.shopId) {
        this.getCount();
        this.getMyNoticeList();
      } else {
        this.getCounts();
      }
      this.getOrderCounts();

      this.getUserInfoFun();
    },
    activated() {},
    mounted() {},
    methods: {
      ...mapActions(["getUserInfo"]),
      goUrl(data) {
        if (data && !data.isToApp) {
          this.$router.push({ name: data.url });
        } else if (data && data.isToApp) {
          try {
            window.native[data.appMethod]();
          } catch (e) {
            if (data.url) {
              this.$router.push({ name: data.url });
            }
          }
        }
      },

      getCount() {
        let params = {
          day: this.dateValue,
          shopId: this.shopId,
        };
        qryShopInfoCount(params).then((res) => {
          this.countEntity = res.data;
          console.info("--------------")
          console.info(this.countEntity)
          if(this.countEntity == null){
            this.countEntity = {};
          }
        });
      },

      getCounts() {
        getAccountCount({ countType: 0 }).then((res) => {
          if (res.code === 0) {
            this.countEntity = res.data;
            console.info("--------------")
            console.info(this.countEntity)
            if(this.countEntity == null){
              this.countEntity = {};
            }
          }
        });
      },

      getOrderCounts() {
        let params = {
          shopId: this.shopId || null,
        };
        getOrderCountNum(params).then((res) => {
          this.orderCountEntity = res.data;
        });
      },
      scan() {
        let projectName = this.aliasName;

        let userAgent = readUserAgent();
        if (userAgent.terminalType.weixin) {
          this.wxScan();
        } else {
          try {
            let _this = this;
            //小鲜柜 udian 如果账号没有shopId 则是管理端账号 扫码必须是扫柜子二维码
            //如果有shopId 则是商家端账号， 扫码必须是核销二维码
            if (
                    (projectName == "yyagro" && (this.shopId ==null || this.shopId == '')) ||
                    projectName == "ylLive" || projectName == "yumofang"||
                    (projectName == "udian" && (this.shopId ==null || this.shopId == ''))
            ) {
              // let result = u.native.scanMulti(1);
              // console.log(result);
              u.native.scanMulti(1, function (respon) {
                console.log(respon);
                if (respon) {
                  let result = JSON.parse(respon);
                  if (result.data && result.data.result) {
                    _this.sacnResultHandler(result);
                  }
                }
              });
            } else {
              u.native.scan(function (respon) {
                if (respon) {
                  let result = respon;
                  if (result) {
                    if (String(result) == Number(result)) {
                      _this.$router.push({
                        name: "orderDetail",
                        query: { orderId: result, isScan: true },
                      });
                    } else {
                      // _this.$toast('请扫描待核销订单二维码');
                      _this.$router.push({
                        name: "scanBlank",
                        query: { content: result },
                      });
                    }
                  }
                }
              });
            }
          } catch (e) {
            this.$toast("请在App上操作"+e);

            // let _this = this;
            // let result = '675367552838270976'
            // if(String(result) == Number(result)){
            //     _this.$router.push({name:'orderDetail',query:{orderId: result,isScan:true}})
            // }else{
            //     _this.$toast('请扫描待核销订单二维码');
            // }
          }
        }
      },
      getMyNoticeList() {
        let params = {
          page: 1,
          limit: 5,
        };
        myMsgNoticeList(params).then((res) => {
          if (res.data && res.data.records.length > 0) {
            this.curNotice = res.data.records[0];
          }
        });
      },

      getUserInfoFun() {
        try {
          window.native.getApp();
          this.getUserInfo()
                  .then((res) => {
                    // this.isQuarterManageRole = res.isQuarterManageRole;
                    // this.isSupplierRole = res.isSupplierRole;
                  })
                  .finally(() => {
                    // this.loadState = 'finish';
                  });
        } catch (e) {}
      },

      refreshOrderCount() {
        if (this.shopId) {
          this.getCount();
        } else {
          this.getCounts();
        }
        this.getOrderCounts();
      },

      sacnResultHandler(result) {
        let _this = this;
        let bol = isURL(result.data.result); //是否是url链接
        if (bol) {
          let params = parseUrl(result.data.result);
          _this.eqShopId = params.shopId;
          _this.otype = params.otype || "buy";
          _this.eqType = params.equipmentType || "rfid";
          _this.doorType = params.doorType || ""; //开门类型，双码或单码
          _this.sectionNo = params.sectionNo || ""; //左门或右门
          if (result.data.type == 1 || result.data.type == 0) {
            if (_this.otype == "buy") {
              //称重柜，类型为双码需要判断是左门还是右门
              if (_this.eqType == "weigh") {
                if (_this.doorType == "double") {
                  if (_this.sectionNo == "") {
                    _this.$toast("开门失败");
                    return;
                  }
                }
              }
              let requestPar = {
                accessToken: getToken(),
                shopId: _this.eqShopId,
              };
              openDoorForAdmin(requestPar).then((res) => {
                if (res.code == 0) {
                  _this.$toast("开门成功");
                  if (_this.eqType == "weigh") {
                    _this.$router.push({
                      name: "supplyCompare",
                      query: { shopId: _this.eqShopId },
                    });
                  }
                }
              });
            } else if (_this.otype == "locker") {
              _this.$router.push({
                name: "lockerCargoList",
                query: { shopId: _this.eqShopId },
              });
            }
          } else {
            if(this.isOutSupplierRole){
              _this.$toast("没有开放权限！");
            }else{
              _this.$router.push({
                name: "equipmentHome",
                query: { shopId: _this.eqShopId },
              });
            }

          }
        } else {
          _this.$toast("请扫描柜子二维码");
        }
      },

      getWXConfig() {
        let _this = this;
        //获取微信权限验证参数
        let configParams = {
          url: window.location.href.split("#")[0],
          aliasName: this.aliasName,
        };
        getWXconfigParams(configParams)
                .then((res) => {
                  let config = JSON.parse(res.data);
                  wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: config.appId, // 必填，公众号的唯一标识
                    timestamp: config.timestamp, // 必填，生成签名的时间戳
                    nonceStr: config.nonceStr, // 必填，生成签名的随机串
                    signature: config.signature, // 必填，签名，见附录1
                    jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                  });
                  wx.ready(function () {
                    // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
                    // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
                    wx.checkJsApi({
                      // 判断当前客户端版本是否支持指定JS接口
                      jsApiList: ["scanQRCode"],
                      success: function (res) {
                        // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
                        if (res.checkResult.scanQRCode === true) {
                          _this.canScan = true;
                        } else {
                          _this.canScan = false;
                          alert("抱歉，当前客户端版本不支持扫一扫");
                        }
                      },
                      fail: function (res) {
                        // 检测getNetworkType该功能失败时处理
                        alert("fail" + res);
                      },
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
      },

      wxScan() {
        if (!this.canScan) {
          this.$toast("抱歉，当前客户端版本不支持扫一扫");
          return;
        }
        let _this = this;
        wx.scanQRCode({
          // 微信扫一扫接口
          desc: "微信扫一扫",
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (response) {
            console.log("扫描结果", response);
            let result = response.resultStr; // 当needResult 为 1 时，扫码返回的结果
            alert(result);
            let resultParams = {
              data: {
                type: 1,
                result,
              },
            };
            _this.sacnResultHandler(resultParams);
          },
          fail: function () {
            this.saving = false;
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .page {
    padding-bottom: 1.2rem;
  }
  .page-title {
    width: 100%;
    padding: 0.25rem;
    display: flex;
    background: #fff;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
    z-index: 200;
    justify-content: space-between;
    align-items: center;
    .right-icon {
      font-size: 0.48rem;
    }
  }
  .sys-tip {
    display: flex;
    align-items: center;
    background: #ffe3a2;
    border-radius: 0.12rem;
    padding: 0.12rem 0;
    margin-bottom: 0.2rem;
    .alifont {
      margin: 0 0.25rem;
      color: #795605;
      &.left {
        font-size: 0.4rem;
      }
      &.right {
        font-size: 0.28rem;
      }
    }
    .text {
      flex: 1;
      color: #795605;
    }
  }
  .main-content {
    width: 100%;
    border-radius: 0.12rem;
    background: $main-color;
    padding: 0.34rem 0.36rem 0.28rem;
    position: relative;
    .sale-money {
      font-size: 0.62rem;
      line-height: 0.76rem;
      color: #fff;
      margin-top: 0.04rem;
    }
    .yesterday {
      display: inline-block;
      height: 0.48rem;
      background: rgba(0, 0, 0, 0.1);
      border-radius: 0.27rem;
      padding: 0 0.28rem;
      line-height: 0.48rem;
      font-size: 0.24rem;
      color: #fff;
      margin-top: 0.1rem;
    }
    .opc {
      position: absolute;
      width: 6.6rem;
      height: 0.5rem;
      background: $main-color;
      border-radius: 0.12rem;
      opacity: 0.64;
      filter: blur(0.1rem);
      left: 0.2rem;
      bottom: -0.07rem;
    }
  }
  .order-tip {
    border-radius: 0.12rem;
    border: 0.02rem solid #dcdcdc;
    margin-top: 0.4rem;
    padding: 0.3rem 0;
    font-weight: bold;
    .left {
      position: relative;
      &:after {
        position: absolute;
        content: "";
        width: 0.02rem;
        height: 100%;
        top: 0;
        right: 0;
        background: #dcdcdc;
      }
    }
  }
  .com-content {
    margin-top: 0.63rem;
    .content-list {
      display: flex;
      flex-wrap: wrap;
    }
    .content-item {
      width: 33.3333%;
      text-align: center;
      margin-top: 0.35rem;
      img {
        width: 0.96rem;
        height: 0.96rem;
      }
    }
  }
  .scan-img {
    width: 2.46rem;
    height: 0.95rem;
    position: fixed;
    bottom: 0;
    left: 50%;
    margin-left: -1.23rem;
  }
  .opc-08 {
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?2582f22f